import React from 'react'
import {connect} from "react-redux";
import BmPort from "./BmPort";
import AccPort from "./AccPort";

const Acc = ({node, header, size}) => {
    const _size = size || 32

    let zz = []
    if( node && node.acc_states) {
        for (let x of Object.keys(node.acc_states)) {
            let yy = node.acc_states[x]
            if( yy.acc_total > 0) {
                zz.push(<AccPort key={node.uid + "_" + yy.acc_port} uid={node.uid} port={yy} size={_size}/>)
            }
        }
    }

    const _uid = node && node.uid && `V${node.uid.slice(4, 6)}P${node.uid.slice(6)}`
    const _user = node && node.user.replaceAll('http://', '').replace(/:[0-9]+/, '')
    const _prod = node && node.product
    const _title = header && `${_user || _uid} (${_prod})` // + ` | ${node && node.path} | ${node && node.uid}`

    return (
        <div style={{
            margin: 5,
        }}>
            <div style={{
                padding: '5px',
            }}>{_title}</div>
            <div style={{
                display: 'inline-grid',
                gridTemplateColumns: 'repeat(8, auto)', //`repeat(8, ${_size || 'auto'})`,
                padding: '2px',
                gridGap: '5px',
                marginLeft: '5px',
                marginBottom: '5px',
            }}>
                {zz}
            </div>
        </div>
    )
}

function mapStateToProps(state, other) {
    return {node: state.bidib.data.node.find(it => it.uid === other.nodeid)}
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Acc)